import { AppSettingsService } from '@core/services/app-settings/app-settings.service';
import { FeatureFlagsInitService } from '@shared/components/feature-toggle/services/feature-flags-init.service';
import { AuthB2CService, LogService } from 'common-web-core';

export function initializeAppDependencies(
  appSettingsService: AppSettingsService,
  authB2cService: AuthB2CService,
  logService: LogService,
  featureFlagsInitService: FeatureFlagsInitService
): any {
  return async (): Promise<[void, void]> => {
    const appSettings = await appSettingsService.initApplicationSettings();

    logService.initialize(appSettings.loggerSettings);

    return await Promise.all([
      featureFlagsInitService.initialize(),
      authB2cService.initialize(appSettings.b2cSettings)
    ]);
  };
}
